import React from 'react';
import { PolaGroupSection } from '../components/PolaGroupSection';
import { SolutionsSection } from '../components/SolutionsSection';
export function AboutPage() {
  return <div className="pt-28" data-id="element-787">
      <PolaGroupSection data-id="element-788" />
      <SolutionsSection data-id="element-789" />
    </div>;
}